import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/defineProperty";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from "element-ui";
import { changeBindPhone, returnData } from "@/api/loginConfig/addUserList";
import crypto from 'crypto';
export default {
  name: "adduserPage",
  props: {
    showing: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var _ref;

    return _ref = {
      dialogFormVisible: false,
      titleName: "",
      id: "",
      names: '手机号',
      form: {
        value: ''
      },
      rules: {
        value: [{
          required: true,
          message: '请输入手机号',
          trigger: 'blur'
        }, {
          min: 11,
          max: 11,
          message: '手机号码格式不正确',
          trigger: 'blur'
        }]
      },
      searchgames: [],
      searchplatforms: [],
      searchchannels: [],
      searchpkgs: [],
      gameId: "",
      value1: "",
      value2: [],
      searchMark: {},
      searchData: {}
    }, _defineProperty(_ref, "id", ""), _defineProperty(_ref, "formLabelWidth", "80px"), _ref;
  },
  created: function created() {
    this.searchMark = {};
  },
  watch: {//   obj(val) {
    //     if(showing){
    //    this.searchData =  JSON.parse(JSON.stringify(val))
    //   }
    // },
  },
  computed: {
    isShow: {
      get: function get() {
        if (this.showing) {
          return this.showing;
        }
      },
      set: function set(val) {
        this.$emit("changeShow", false);
      }
    }
  },
  methods: {
    init: function init(id, item, num) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var tid, _yield$returnData, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogFormVisible = true;

                if (!(num == 2)) {
                  _context.next = 10;
                  break;
                }

                _this.titleName = "换绑手机";
                _this.form = {};
                tid = {
                  user_id: id,
                  game: item.game,
                  platform: item.platform,
                  channel: item.channel
                };
                _context.next = 7;
                return returnData(tid);

              case 7:
                _yield$returnData = _context.sent;
                data = _yield$returnData.data;
                _this.searchData = _objectSpread({}, data);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    yz: function yz(value) {
      var reg = /^[1][3,4,5,7,8][0-9]{9}$/;
      var re = new RegExp(reg);

      if (re.test(phone)) {
        th.iphonePss = true;
        return true;
      } else {
        th.iphonePss = false;
        return false;
      }
    },
    valChange: function valChange(val) {
      this.searchData["phone"] = val;
    },
    resetForm: function resetForm(formName) {
      this.dialogFormVisible = false;
      this.$emit("refreshDataList");
      this.$emit("changeShow", false);
    },
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this2 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          if (_this2.titleName == "换绑手机") {
            // console.log(this.searchData, "kkkk")
            _this2.searchMark.game = _this2.searchData.game;
            _this2.searchMark.platform = _this2.searchData.platform;
            _this2.searchMark.channel = _this2.searchData.channel;
            _this2.searchMark.pkg = _this2.searchData.pkg;
            _this2.searchMark.user_id = _this2.searchData.user_id;
            _this2.searchMark.phone = _this2.searchData.phone;
            _this2.searchMark.ad_channel = _this2.searchData.ad_channel ? _this2.searchData.ad_channel : 'default';
            _this2.searchMark.ad_placement = _this2.searchData.ad_placement ? _this2.searchData.ad_placement : 'default';
            _this2.searchMark.kind = 1;
            changeBindPhone(_this2.searchMark).then(function (res) {
              if (res.status == 200) {
                Message.success(res.message);

                _this2.resetForm("ruleForm");
              } else {
                Message.warning(res.message);

                _this2.resetForm("ruleForm");
              }
            });
          }
        } else {
          return false;
        }
      });
    }
  },
  clearData: function clearData() {
    this.form = {};
    this.searchplatforms = [];
    this.searchchannels = [];
    this.searchpkg = [];
  }
};